/**
 * Image Tone Mapping — heuristic emotional-tone tagging.
 *
 * Phase 1: derive default tones from a category id. Future phases can
 * add per-URL overrides or AI-classified tones.
 */

export const EMOTIONAL_TONES = [
  "warm",
  "expansive",
  "sacred",
  "abundant",
  "vibrant",
  "minimal",
  "natural",
  "sensual",
  "ethereal",
  "grounded",
];

// Default tones per LivingVisionBoard category id.
export const CATEGORY_TONE_MAP = {
  wealth:        ["abundant", "warm", "expansive"],
  freedom:       ["expansive", "ethereal"],
  faith:         ["sacred", "grounded"],
  cosmic:        ["expansive", "ethereal", "sacred"],
  family:        ["warm", "grounded", "natural"],
  contribution:  ["warm", "sacred"],
  sports:        ["vibrant", "expansive", "grounded"],
  creative:      ["vibrant", "sensual"],
  luxury:        ["abundant", "sensual", "warm"],
  pets:          ["warm", "natural"],
  health:        ["natural", "vibrant", "grounded"],
  presence:      ["minimal", "ethereal"],
  healing:       ["sacred", "ethereal", "warm"],
};

/**
 * Resolve tones for an image. Prefers explicit `image.tones` if present,
 * otherwise falls back to the category map.
 */
export function tonesForImage(image, categoryId) {
  if (image?.tones && Array.isArray(image.tones) && image.tones.length) {
    return image.tones.filter((t) => EMOTIONAL_TONES.includes(t));
  }
  const cat = categoryId || image?.category;
  return CATEGORY_TONE_MAP[cat] || [];
}
